module.exports = "/_next/static/images/gurugram-2x-7a0a0f4557accbdf701d1ae419bb529d.png";